import logo from 'frassinoro-theme/components/Logo/logo-comune-frassinoro.webp';

export default function Logo() {
  return (
    <figure className="header-logo">
      <img src={logo} alt="Comune di Frassinoro" width="157" height="82" />
    </figure>
  );
}
